import searchIcon from "../../assets/list-search.svg";
import "./custom-search.scss";

const CustomSearch: React.FC<any> = ({onChange}) => {
  return (
    <div className="custom-search-container">
      <div className="search-box">
        <input type="text" className="custom-search-input" placeholder="Search..." onInput={onChange} />
        <img src={searchIcon} />
      </div>
    </div>
  );
};

export default CustomSearch;
